import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { env } from "configs/EnvironmentConfig";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_CANCEL,
  AUTH_STATUS_CANCEL_WAITING,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_REJECT_CANCEL,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
} from "constants/FormatDataContanst";
import { TYPE_ADJUST_INVOICE } from "constants/IssueInvoiceConstant";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { numberWithCommas } from "helpers/utils";
import ErrorReleaseModal from "pages/DataFormatInvoice/modal/ErrorReleaseModal";
import HistoryTransferModal from "pages/DataFormatInvoice/modal/HistoryTransferModal";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import DetailInvoice from "pages/IssueInvoice/DetailInvoice";
import { getInvoiceStatus } from "pages/IssueInvoice/helper/functionHelper";
import PDFViewModal from "pages/IssueInvoice/modal/PDFViewModal";
import {
  issueInvoiceModeList,
  issueInvoicePageViewList,
} from "pages/IssueInvoice/utils";
import PropTypes from "prop-types";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { Badge, Col, Row, UncontrolledTooltip } from "reactstrap";
import { listIssueInvoice } from "store/actions";

const ListInvoiceCampaign = forwardRef((props, ref) => {
  const { t, campaign_id } = props;

  const [commonStatus, setCommonStatus] = useState(getInvoiceStatus(t));

  useEffect(() => {
    setCommonStatus(getInvoiceStatus(t));
  }, [t]);

  useImperativeHandle(ref, () => ({
    queryDataListInvoice() {
      queryData();
    },
  }));

  const [mode, setMode] = useState("");
  const [pageView, setPageView] = useState(null);

  // modalHistoryTransfer
  const [idHistory, setIdHistory] = useState(null);
  const [modalHistoryTransfer, setModalHistoryTransfer] = useState(false);
  const toggleHistoryTransferModal = () =>
    setModalHistoryTransfer(!modalHistoryTransfer);

  // modalErrorRelease
  const [idRelease, setIdRelease] = useState(null);
  const [modalErrorRelease, setModalErrorRelease] = useState(false);
  const toggleErrorReleaseModal = () =>
    setModalErrorRelease(!modalErrorRelease);

  // modalPDFView
  const [modalPdfView, setModalPdfView] = useState(false);
  const [dataViewDocument, setDataViewDocument] = useState(null);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);

  const showPdfById = id => {
    setDataViewDocument({
      id,
    });
    togglePdfViewModal();
  };

  // modalConfirmAction (Replace or Adjust invoice)
  const [dataConfirmAction, setDataConfirmAction] = useState(null);
  const [modalConfirmAction, setModalConfirmAction] = useState(false);
  const toggleConfirmActionModal = () =>
    setModalConfirmAction(!modalConfirmAction);

  const queryData = () => {
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
      "filter[campaign_id]": campaign_id,
    };
    dispatch(listIssueInvoice(issueInvoiceList.params));
  };

  const dispatch = useDispatch();

  const { addToast } = useToasts();

  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    loadingList,
    errorList,
    list: issueInvoiceList,
    fileDownload,
    fileDownloadName,
    type,
    deleteInvoice,
    cancelInvoice,
    successClone,
    workflowInvoice,
    exportInvoiceData,
  } = issueInvoice;
  const [columnsTable, setColumnsTable] = useState([]);

  // When Data Use For Table Changed
  useEffect(() => {
    if (issueInvoiceList) {
      setColumnsTable(initColumns);
    }

    if (issueInvoiceList.columnsVisibleInvoice) {
      initColumn();
    }
  }, [issueInvoiceList]);

  // Action list And Change Language
  useEffect(() => {
    // Set default value to page|sizePerPage when change Language
    issueInvoiceList.params.page = 1;
    issueInvoiceList.params.sizePerPage = 10;
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
    };

    initColumn();
  }, [dispatch, t]);

  const initColumn = () => {
    if (issueInvoiceList.columnsVisibleInvoice) {
      for (const item of initColumns) {
        if (
          issueInvoiceList.columnsVisibleInvoice[item.dataField] !== undefined
        ) {
          item.hidden = !issueInvoiceList.columnsVisibleInvoice[item.dataField];
        }
      }
    }
    setColumnsTable(initColumns);
  };

  const getAuthStatus = row => {
    let status = row.auth_status;
    let process_status = row.process_status;
    let id = row.id;
    let child = row.child;
    let root = row.root;
    let infoError = null;
    let progressDiv = null;
    let info = null;
    if (
      status === AUTH_STATUS_REJECT ||
      status === AUTH_STATUS_RRE ||
      status === AUTH_STATUS_RR
    ) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
          }}
        ></i>
      );
    }
    if (status === AUTH_STATUS_APPROVE) {
      progressDiv = (
        <div className="d-flex gap-1 mt-2">
          <Badge
            className={`font-size-12 ${commonStatus?.PROGRESS_STATUS[process_status]?.badgeColor}`}
            pill
          >
            {commonStatus?.PROGRESS_STATUS[process_status]?.text}
          </Badge>
        </div>
      );
    }
    let dataCompare = {
      leftInvoice: null,
      rightInvoice: null,
      tthdlquan_tchdon: null,
      typeChange: null,
    };
    let textInfo = "";
    if (child || root || row.tthdlquan_lhdclquan === "3") {
      // ID của hóa đơn thay thế/ điều chỉnh cho hóa đơn hiện tại
      dataCompare.tthdlquan_tchdon = row.tthdlquan_tchdon;
      let adjust_mod = null;
      let typeChange = " thay thế";
      if (dataCompare.tthdlquan_tchdon) {
        adjust_mod = row.adjust_mod;
      } else {
        adjust_mod = child.adjust_mod;
      }
      switch (adjust_mod) {
        case TYPE_ADJUST_INVOICE.INCREASE:
          typeChange = " điều chỉnh tăng";
          break;
        case TYPE_ADJUST_INVOICE.DECREASE:
          typeChange = " điều chỉnh giảm";
          break;
        case TYPE_ADJUST_INVOICE.CHANGE_INFO:
          typeChange = " điều chỉnh thông tin";
          break;
        default:
          break;
      }
      dataCompare.typeChange = typeChange;
      if (child) {
        dataCompare.leftInvoice = {
          current: " (Hiện tại)",
          id: row.id,
          khmshdon: row.ttchung_khmshdon,
          khhdon: row.ttchung_khhdon,
          shdon: row.ttchung_shdon,
          nlap: tableFormateDate(row.ttchung_nlap),
        };
        dataCompare.rightInvoice = {
          id: child.id,
          khmshdon: child.ttchung_khmshdon,
          khhdon: child.ttchung_khhdon,
          shdon: child.ttchung_shdon,
          nlap: tableFormateDate(child.ttchung_nlap),
        };
      }
      // ID của hóa đơn bị hóa đơn hiện tại thay thế/ điều chỉnh
      if (root) {
        textInfo = " bị";
        dataCompare.leftInvoice = {
          id: root.id,
          khmshdon: root.ttchung_khmshdon,
          khhdon: root.ttchung_khhdon,
          shdon: root.ttchung_shdon,
          nlap: tableFormateDate(root.ttchung_nlap),
        };
        dataCompare.rightInvoice = {
          current: " (Hiện tại)",
          id: row.id,
          khmshdon: row.ttchung_khmshdon,
          khhdon: row.ttchung_khhdon,
          shdon: row.ttchung_shdon,
          nlap: tableFormateDate(row.ttchung_nlap),
        };
      }
      if (row.tthdlquan_lhdclquan === "3") {
        textInfo = " bị";
        dataCompare.leftInvoice = {
          id: null,
          current: " (Thông tư 32)",
          khmshdon: row.tthdlquan_khmshdclquan,
          khhdon: row.tthdlquan_khhdclquan,
          shdon: row.tthdlquan_shdclquan,
          nlap: tableFormateDate(row.tthdlquan_nlhdclquan),
          gchu: row.tthdlquan_gchu,
        };
        dataCompare.rightInvoice = {
          current: " (Hiện tại)",
          id: row.id,
          khmshdon: row.ttchung_khmshdon,
          khhdon: row.ttchung_khhdon,
          shdon: row.ttchung_shdon,
          nlap: tableFormateDate(row.ttchung_nlap),
        };
      }
      info = (
        <i
          style={{ cursor: "pointer" }}
          title={
            "Hiển thị thông tin hóa đơn" + textInfo + dataCompare.typeChange
          }
          className="font-size-17 bx bx-info-circle text-info"
          onClick={() => {
            // TO_DO
            setDataCompare(dataCompare);
            toggleCompareInvoiceModal();
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            style={{ width: "110px", whiteSpace: "initial" }}
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>

          {infoError}
          {info}
        </div>
        {/* {progressDiv} */}
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Đã phát hành",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Chờ phát hành",
    [AUTH_STATUS_REJECT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text, // "Từ chối phát hành",
    // [AUTH_STATUS_REPLACE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REPLACE]?.text, // "Thay thế",
    // [AUTH_STATUS_EDIT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_EDIT]?.text, // "Điều chỉnh",
    [AUTH_STATUS_CANCEL_WAITING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_CANCEL_WAITING]?.text, // "Chờ duyệt hủy",
    [AUTH_STATUS_REJECT_CANCEL]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT_CANCEL]?.text, // "Từ chối hủy",
    [AUTH_STATUS_CANCEL]: commonStatus?.AUTH_STATUS[AUTH_STATUS_CANCEL]?.text, // "Hủy",

    [AUTH_STATUS_AR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_AR]?.text, // Đã tiếp nhận đăng ký
    // [AUTH_STATUS_ARE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_ARE]?.text, // Đã tiếp nhận thay đổi

    [AUTH_STATUS_RR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RR]?.text, //"Từ chối tiếp nhận đăng ký",
    // [AUTH_STATUS_RRE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RRE]?.text, //"Từ chối tiếp nhận thay đổi"
  };

  const getSelectFilterAuthStatus = () => {
    const filter = {};
    for (const item of [
      AUTH_STATUS_NEW,
      AUTH_STATUS_APPROVE,
      AUTH_STATUS_PROGRESSING,
      AUTH_STATUS_REJECT,
      AUTH_STATUS_CANCEL_WAITING,
      AUTH_STATUS_REJECT_CANCEL,
      AUTH_STATUS_CANCEL,
      AUTH_STATUS_AR,
      AUTH_STATUS_RR,
    ]) {
      if (selectFilterAuthStatus[item]) {
        filter[item] = selectFilterAuthStatus[item];
      }
    }
    return filter;
  };

  const initColumns = [
    // {
    //   dataField: "pban",
    //   text: t("table.version"),
    //   // sort: true,
    //   // filter: textFilter({
    //   //   placeholder: t("placeholder.enter", {
    //   //     title: t("table.message_sender"),
    //   //   }),
    //   // }),
    // },
    {
      dataField: "id",
      text: "id",
      sort: true,
      hidden: env.API_AIR_BRAKE_ENV !== "dev",
    },
    {
      dataField: "client_ref_uuid",
      text: "Số tham chiếu",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      formatter: (cell, row) => {
        return (
          <div style={{ maxWidth: "200px", whiteSpace: "initial" }}>{cell}</div>
        );
      },
    },
    {
      dataField: "nmua_ten",
      text: "Tên khách hàng",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      formatter: (cell, row) => {
        return (
          <div style={{ width: "400px", whiteSpace: "initial" }}>{cell}</div>
        );
      },
    },
    {
      dataField: "nmua_mst",
      text: "MST KH",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "ttoan_tgtttbso",
      text: "Tổng tiền",
      sort: true,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //   }),
      formatter: (cell, row) => {
        return numberWithCommas(cell);
      },
    },

    // {
    //   dataField: "ttchung_thdon",
    //   text: t("table.invoice_name"),
    //   sort: true,
    //   filter: textFilter({
    //     placeholder: t("placeholder.enter"),
    //   }),
    // },
    {
      dataField: "auth_status",
      text: t("auth_status.name"),
      hidden: false,
      formatter: (cellContent, row) => getAuthStatus(row),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: getSelectFilterAuthStatus(),
        style: { maxWidth: "129px" },
      }),
    },
    // {
    //   dataField: "ttchung_khmshdon",
    //   text: t("table.invoice_model_number_symbol"),
    //   hidden: true,
    // },
    {
      dataField: "ttchung_khhdon",
      text: t("table.invoice_symbol"),
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      formatter: (cellContent, row) =>
        row.ttchung_khmshdon + row.ttchung_khhdon,
    },
    {
      dataField: "ttchung_shdon",
      text: t("table.invoice_number"),
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      formatter: (cellContent, row) => {
        return cellContent !== "0" && cellContent ? cellContent : "Chờ cấp số";
      },
    },
    {
      dataField: "ttchung_nlap",
      text: t("table.date_created"),
      formatter: (cellContent, row) => tableFormateDate(row.ttchung_nlap),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={issueInvoiceList.params.columnFilter}
        />
      ),
    },
    {
      dataField: "ttchung_khmshdon",
      text: "Loại Hóa đơn",
      hidden: false,
      formatter: (cellContent, row) => {
        let content = "";
        let info = null;
        let passersbyRoot = row.passersbyRoot;
        let passersbyChild = row.passersbyChild;
        if (passersbyRoot) {
          info = (
            <div
              id={"message" + row.id}
              className="font-size-14 text-primary d-flex gap-1 align-items-center"
              style={{ cursor: "pointer" }}
            >
              Cho doanh nghiệp
              <i
                //   style={{ cursor: "pointer" }}
                className="bx bx-info-circle text-primary"
              ></i>
              <UncontrolledTooltip
                placement="left"
                style={{
                  textAlign: "left",
                  fontSize: "15px",
                  background: "white",
                  color: "black",
                  border: "1px solid blue",
                  minWidth: "300px",
                }}
                target={"message" + row.id}
              >
                <span style={{ fontWeight: "bold" }} className="text-primary">
                  Được tạo từ hóa đơn khách hàng lẻ.
                </span>{" "}
                <br />
                Số hóa đơn: {passersbyRoot.ttchung_shdon} <br />
                Ký hiệu: {passersbyRoot.ttchung_khmshdon}
                {passersbyRoot.ttchung_khhdon}
                <br />
                Id: {passersbyRoot.id}
              </UncontrolledTooltip>
            </div>
          );
        }
        if (passersbyChild) {
          info = (
            <div
              style={{ cursor: "pointer" }}
              id={"message" + row.id}
              className="font-size-14 text-success d-flex gap-1 align-items-center"
            >
              Cho khách hàng lẻ
              <i
                //   style={{ cursor: "pointer" }}
                className="bx bx-info-circle text-success"
              ></i>
              <UncontrolledTooltip
                placement="left"
                style={{
                  textAlign: "left",
                  fontSize: "15px",
                  background: "white",
                  color: "black",
                  border: "1px solid green",
                  minWidth: "300px",
                }}
                target={"message" + row.id}
              >
                <span style={{ fontWeight: "bold" }} className="text-success">
                  Đã tạo hóa đơn doanh nghiệp
                </span>{" "}
                <br />
                Số hóa đơn:{" "}
                {passersbyChild.ttchung_shdon
                  ? passersbyChild.ttchung_shdon
                  : "Chưa cấp số"}{" "}
                <br />
                Ký hiệu: {passersbyChild.ttchung_khmshdon}
                {passersbyChild.ttchung_khhdon}
                <br />
                Id: {passersbyChild.id}
              </UncontrolledTooltip>
            </div>
          );
        }
        switch (cellContent) {
          case "1":
            content = "HÓA ĐƠN GTGT";
            break;
          case "2":
            content = "HÓA ĐƠN BH";
            break;
          default:
            break;
        }
        return (
          <React.Fragment>
            <div style={{ maxWidth: "230px", whiteSpace: "initial" }}>
              <div>{content}</div> {info}
            </div>
          </React.Fragment>
        );
      },
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: {
          1: "HÓA ĐƠN GTGT",
          2: "HÓA ĐƠN BH",
        },
      }),
    },
    {
      dataField: "sent",
      text: "Trạng thái gửi mail",
      sort: true,
      formatter: (cellContent, row) => {
        if (cellContent === 0) {
          return (
            <div className="d-flex gap-1 mt-2">
              <Badge className={`font-size-12 badge-soft-warning`} pill>
                Chưa gửi mail
              </Badge>
            </div>
          );
        } else if (cellContent === 1) {
          return (
            <div className="d-flex gap-1 mt-2">
              <Badge className={`font-size-12 badge-soft-success`} pill>
                Đã gửi mail
              </Badge>
            </div>
          );
        }
      },
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: {
          0: "Chưa gửi mail",
          1: "Đã gửi mail",
        },
      }),
    },
    {
      dataField: "maker.display_name",
      text: t("table.maker_id"),
      sort: true,
    },
    {
      dataField: "checker_date",
      text: t("table.checker_date"),
      sort: true,
      formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={issueInvoiceList.params.columnFilter}
        />
      ),
    },
  ];

  const onSearchAllHandle = value => {
    issueInvoiceList.params.keywords = value;
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
    };
    queryData();
  };

  const setPageViewByRow = row => {
    let pageView = "";
    if (row.invoice_type)
      switch (row.ttchung_khmshdon) {
        // Hóa đơn GTGT
        case "1":
          switch (row.invoice_type) {
            case "1":
              pageView = issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE;
              break;
            case "0":
              pageView = issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE;
              break;
            default:
              break;
          }
          break;
        // Hóa đơn Bán hàng
        case "2":
          switch (row.invoice_type) {
            case "1":
              pageView = issueInvoicePageViewList.PAGE_SALE_INVOICE_HAVE_CODE;
              break;
            case "0":
              pageView = issueInvoicePageViewList.PAGE_SALE_INVOICE_NONE_CODE;
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
    setPageView(pageView);
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {
      //   getListInvoiceSymbol(row.ttchung_khmshdon);
      setDataConfirmAction({
        typeAdjust: row.adjust_mod,
      });
      setPageViewByRow(row);
      setDataDetail({
        id: row.id,
        tthdlquan_tchdon: row.tthdlquan_tchdon,
        root: row.root,
        child: row.child,
        tthdlquan_lhdclquan: row.tthdlquan_lhdclquan,
        tthdlquan_khmshdclquan: row.tthdlquan_khmshdclquan,
        tthdlquan_khhdclquan: row.tthdlquan_khhdclquan,
        tthdlquan_shdclquan: row.tthdlquan_shdclquan,
        tthdlquan_nlhdclquan: row.tthdlquan_nlhdclquan,
      });
      switch (row.ttchung_khmshdon) {
        case "1":
          setMode(issueInvoiceModeList.VIEW_VAT_INVOICE_DETAIL);
          break;
        case "2":
          setMode(issueInvoiceModeList.VIEW_SALE_INVOICE_DETAIL);
          break;
        default:
          break;
      }
      toggleDetailModal();
    },
  };

  const listRowAction = [
    {
      icon: <i className="bx bxs-file-pdf font-size-18 text-danger" />,
      text: "Xem trước bản hiển thị",
      onClick: row => {
        showPdfById(row.id);
      },
    },
    {
      icon: <i className="bx bx-history font-size-18 text-success" />,
      text: "Lịch sử truyền nhận",
      onClick: row => {
        setIdHistory(row.id);
        toggleHistoryTransferModal();
      },
    },
  ];

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    issueInvoiceList.params.sort = sortField
      ? sortOrder + sortField
      : issueInvoiceList.params.sort;
    issueInvoiceList.params.columnFilter = { ...columnFilter } || {};
    issueInvoiceList.params.page = page || 1;
    issueInvoiceList.params.sizePerPage = sizePerPage || 10;
    queryData();
  };

  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);
  const toggleDetailModal = () => {
    setDetailModal(!detailModal);
  };

  return (
    <Row>
      <Col className="col-12">
        <h4 className="card-title text-primary">
          Danh sách hóa đơn
          {` (${issueInvoiceList.totalCount})`}
        </h4>
        {/* HistoryTransferModal */}
        <HistoryTransferModal
          isOpen={modalHistoryTransfer}
          toggle={toggleHistoryTransferModal}
          id={idHistory}
          path={"invoices"}
        />
        {/* ErrorReleaseModal */}
        <ErrorReleaseModal
          isOpen={modalErrorRelease}
          toggle={toggleErrorReleaseModal}
          id={idRelease}
          path={"invoices"}
        />
        {/* PDFViewModal */}
        <PDFViewModal
          isOpen={modalPdfView}
          dataViewDocument={dataViewDocument}
          toggle={togglePdfViewModal}
        ></PDFViewModal>
        {/* Detail Modal */}
        <DetailInvoice
          isEnterprise={true}
          dataDetail={dataDetail}
          dataConfirmAction={dataConfirmAction}
          isOpenModal={detailModal}
          toggleModal={toggleDetailModal}
          showPdfById={showPdfById}
          mode={mode}
          pageView={pageView}
        />
        <RemoteDataTable
          // selectRow={selectRowCheckbox}
          // onRowsSelect={onRowsSelect}
          // expandRow={expandRowTable}
          keyField="id"
          data={issueInvoiceList.items}
          columns={columnsTable}
          page={issueInvoiceList.params.page}
          sizePerPage={issueInvoiceList.params.sizePerPage}
          totalSize={issueInvoiceList.totalCount}
          onTableChange={handleTableChange}
          onSearchAllHandle={onSearchAllHandle}
          //   optionShowColumnHandel={optionShowColumnHandler}
          rowEvents={rowEventsHandler}
          //   listMultipleRowAction={listMultipleRowAction}
          listRowAction={listRowAction}
          loading={loadingList}
          customClassTable={"custom-remote-table-modal"}
        ></RemoteDataTable>
      </Col>
    </Row>
  );
});

ListInvoiceCampaign.propTypes = {
  campaign_id: PropTypes.any,
  t: PropTypes.any,
};

export default ListInvoiceCampaign;
